import "core-js/modules/es.array.push.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
import _imports_0 from '@/assets/image/header.png';
const _hoisted_1 = {
  class: "headerImg"
};
const _hoisted_2 = {
  style: {
    "margin-top": "75px",
    "font-size": "18px"
  }
};
const _hoisted_3 = {
  class: "flex-align switch-box"
};
const _hoisted_4 = {
  class: "flex-align"
};
const _hoisted_5 = ["src"];
const _hoisted_6 = {
  class: "ml5"
};
const _hoisted_7 = {
  class: "flex-align"
};
import { ref, computed } from "vue";
import { ERouterName, ELocalStorageKey } from "@/types";
import { ArrowRightBold } from "@element-plus/icons-vue";
import router from "@/router";
import store from "@/store";

import { ElMessageBox, ElMessage } from 'element-plus/es';
import 'element-plus/es/components/base/style/css';
import 'element-plus/es/components/base/style/css';
import 'element-plus/es/components/message-box/style/css';
import 'element-plus/es/components/message/style/css';
export default {
  __name: 'Dropdown',
  setup(__props, {
    expose: __expose
  }) {
    const NickName = localStorage.getItem(ELocalStorageKey.NickName);
    const Username = localStorage.getItem(ELocalStorageKey.Username);
    const dropdown1 = ref();
    function showClick() {
      if (!dropdown1.value) return;
      dropdown1.value.handleOpen();
    }
    __expose({
      showClick
    });
    const _logout = () => {
      ElMessageBox.confirm("确定要退出吗？", {
        confirmButtonText: "退出",
        cancelButtonText: "取消",
        draggable: true,
        center: true
      }).then(() => {
        ElMessage.success("退出成功");
        localStorage.clear();
        store.state.workspace = {};
        router.push(ERouterName.PILOT_LOGIN);
      }).catch(() => {});
    };
    const _center = () => router.push(ERouterName.PILOT_Center);
    const _switch = () => router.push(ERouterName.PILOT_Switch);
    const _back = () => router.push(ERouterName.INFORMATION);
    const showBack = computed(() => {
      if (store.state.workspace?.type_enum == "personal") {
        return false;
      }
      return store.state.workspace?.role != "member";
    });
    const _header = computed(() => {
      if (store.state.workspace?.type_enum == "personal") {
        return new URL("/src/assets/image/geren2.png", import.meta.url).href;
      } else if (store.state.workspace?.type_enum == "group") {
        return new URL("/src/assets/image/zuzhi2.png", import.meta.url).href;
      }
      return new URL("/src/assets/image/header.png", import.meta.url).href;
    });
    const personal = computed(() => {
      if (store.state.workspace?.type_enum == "personal") {
        return "（个人）";
      } else if (store.state.workspace?.type_enum == "group") {
        return "（团体）";
      }
      return "";
    });
    return (_ctx, _cache) => {
      const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
      const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_dropdown = _resolveComponent("el-dropdown");
      return _openBlock(), _createBlock(_component_el_dropdown, {
        ref_key: "dropdown1",
        ref: dropdown1,
        trigger: "contextmenu",
        "popper-class": "no-arrow-menu"
      }, {
        dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, {
          class: "flex-column"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("p", _hoisted_2, _toDisplayString(_unref(NickName)), 1), _createElementVNode("p", null, _toDisplayString('@' + _unref(Username)), 1)]), _createVNode(_component_el_dropdown_item, {
            onClick: _center
          }, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [_createTextVNode("个人设置")])),
            _: 1
          }), _createVNode(_component_el_dropdown_item, {
            onClick: _logout
          }, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [_createTextVNode("退出登录")])),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_dropdown_menu, {
          class: "flex-column"
        }, {
          default: _withCtx(() => [_cache[4] || (_cache[4] = _createElementVNode("div", {
            class: "bordert"
          }, [_createElementVNode("p", {
            class: "ml15 pb10 pt5"
          }, "组织")], -1)), _createVNode(_component_el_dropdown_item, {
            onClick: _switch
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("img", {
              src: _header.value,
              style: {
                "width": "24px",
                "scale": "1.1"
              }
            }, null, 8, _hoisted_5), _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$store.state.workspace?.platform_name + personal.value), 1)]), _createElementVNode("div", _hoisted_7, [_cache[2] || (_cache[2] = _createElementVNode("span", null, "切换", -1)), _createVNode(_component_el_icon, null, {
              default: _withCtx(() => [_createVNode(_unref(ArrowRightBold))]),
              _: 1
            })])])]),
            _: 1
          }), showBack.value ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
            key: 0,
            onClick: _back
          }, {
            default: _withCtx(() => _cache[3] || (_cache[3] = [_createTextVNode("后台管理")])),
            _: 1
          })) : _createCommentVNode("", true)]),
          _: 1
        })]),
        default: _withCtx(() => [_cache[5] || (_cache[5] = _createElementVNode("div", null, [_createElementVNode("img", {
          src: _imports_0,
          style: {
            "width": "28px",
            "height": "28px"
          }
        })], -1))]),
        _: 1
      }, 512);
    };
  }
};